/* eslint-disable react/prop-types */
import { useCallback } from "react";
import { NavLink as ReactNavLink, useNavigate } from "react-router";
import { COOKIES } from "constants/cookies";
import { eraseCookie, getCookie } from "services/cookies";
import { isGCXDomain } from "services/window";

const isAbsoluteHttpUrl = (value) => /^https?:\/\//i.test(value);

const useCustomNavigation = () => {
  const navigate = useNavigate();

  const navigateWithParams = useCallback(
    (url, options) => {
      options ? navigate(url, options) : navigate(url);
    },
    [navigate]
  );

  const customNavigate = useCallback(
    (url, options) => {
      navigateWithParams(url, options);
      // isGCXDomain()
      //   ? window.open(url, "_self")
      //   : navigateWithParams(url, options);
    },
    [navigateWithParams]
  );

  return customNavigate;
};

export const useNavigateByRedirectCookie = () => {
  const navigate = useCustomNavigation();

  const navigateByRedirectCookie = ({ defaultRoute }) => {
    const { RETURN_TO } = COOKIES;
    const redirectCookie = getCookie(RETURN_TO);
    eraseCookie(RETURN_TO);
    if (!redirectCookie) {
      navigate(defaultRoute);
      return;
    }

    let target;
    try {
      target = decodeURIComponent(redirectCookie);
    } catch {
      navigate(defaultRoute);
      return;
    }

    // React Router treats strings that do not start with "/" as relative paths.
    // `return_to` stores full URLs on GCX; passing "https://..." to navigate()
    // incorrectly resolves under the current route (e.g. .../device_verifications/https:...).
    if (isAbsoluteHttpUrl(target)) {
      try {
        const url = new URL(target);
        if (url.origin === window.location.origin) {
          navigate(`${url.pathname}${url.search}${url.hash}`);
        } else {
          window.location.assign(target);
        }
      } catch {
        navigate(defaultRoute);
      }
      return;
    }

    navigate(target);
  };

  return navigateByRedirectCookie;
};

const NavLink = ({ children, target, ...props }) => {
  return isGCXDomain() ? (
    <a href={props.to} target={target || "_self"} {...props}>
      {children}
    </a>
  ) : (
    <ReactNavLink target={target || "_self"} {...props}>
      {children}
    </ReactNavLink>
  );
};

export { useCustomNavigation as useNavigate, NavLink };
